
import Icon from '../../../common/Icon'

export default {
  name: 'LocationPhoneInfo',
  props: {
    data: {
      type: Object,
      default: () => {}
    },
  },
  components: {
    Icon,
  },
  computed: {
    phone() {
      let p = `${this.data?.phone}`
      if (p.length === 10) {
        return `(${p.substring(0, 3)}) ${p.substring(3, 6)}-${p.substring(6, 10)}`
      }

      return this.data?.phone
    },
  },
}
